module.exports = "/static/assets/1fd3942fa102af8c13222be2ccc52e36.svg";